import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexFill,
  ApexMarkers,
  ApexYAxis,
  ApexXAxis,
  ApexTooltip,
  ApexStroke,
  NgApexchartsModule,
} from 'ng-apexcharts'
@Component({
  selector: 'app-graph',
  template: `
    <apx-chart
      [series]="series"
      [chart]="chart"
      [stroke]="stroke"
      [dataLabels]="dataLabels"
      [markers]="markers"
      [title]="title"
      [yaxis]="yaxis"
      [xaxis]="xaxis"
      [tooltip]="tooltip"
      [autoUpdateSeries]="true"
      [colors]="colors"
      [fill]="fill"></apx-chart>
  `,
  styles: [
    `
      .apexcharts-zoom-icon.apexcharts-selected svg {
        fill: #68e397 !important;
      }

      .apexcharts-pan-icon.apexcharts-selected svg {
        stroke: #68e397 !important;
      }
    `,
  ],
  standalone: true,
  imports: [CommonModule, NgApexchartsModule],
})
export class GraphComponent {
  public series!: ApexAxisChartSeries
  public chart!: ApexChart
  public dataLabels!: ApexDataLabels
  public markers!: ApexMarkers
  public title!: ApexTitleSubtitle
  public fill!: ApexFill
  public yaxis!: ApexYAxis
  public xaxis!: ApexXAxis
  public tooltip!: ApexTooltip
  public colors!: string[]
  public stroke!: ApexStroke
  public data: any = {}
  public showQuoteGraph: boolean = false

  

  @Input()
  set showQuoteHistory(showQuoteGraph: boolean) {
    this.showQuoteGraph = showQuoteGraph
  }

  @Input()
  set graphData(data: any) {
    if (data) {
      this.data = data
      this.processData(data)
    }
  }

  public initChartData(dataSeries: any): void {
    let dates = []
    let prices = []
    for (let item of dataSeries) {
      dates.push(item.date)
      prices.push(item.price)
    }

    this.series = [
      {
        name: this.showQuoteGraph ? 'NET_UNIT_PRICE_EURO__C' : 'NETPR',
        data: prices,
      },
    ]
    this.chart = {
      type: 'area',
      stacked: false,
      height: 400,
      zoom: {
        type: 'x',
        enabled: true,
        autoScaleYaxis: true,
      },
      toolbar: {
        autoSelected: 'zoom',
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: false,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
          customIcons: [],
        },
      },
    }
    this.stroke = {
      show: true,
      curve: 'straight',
      lineCap: 'butt',
      colors: undefined,
      width: 3,
      dashArray: 0,
    }
    this.dataLabels = {
      enabled: false,
      style: {
        colors: ['#8a00e5'],
      },
    }
    this.markers = {
      size: 3,
      colors: ['#8a00e5'],
      strokeColors: '#fff',
      strokeWidth: 1,
      strokeOpacity: 0.9,
      strokeDashArray: 0,
      fillOpacity: 1,
      discrete: [],
      shape: 'circle',
      radius: 2,
      offsetX: 0,
      offsetY: 0,
      onClick: undefined,
      onDblClick: undefined,
      showNullDataPoints: true,
      hover: {
        size: undefined,
        sizeOffset: 3,
      },
    }
    this.title = {
      text: '',
      align: 'left',
    }
    this.colors = ['#9a00ff7d']
    this.fill = {
      type: 'gradient',
      gradient: {
        shadeIntensity: 0,
        inverseColors: false,
        opacityFrom: 0,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    }
    this.yaxis = {
      // labels: {
      //   formatter: function(val) {
      //     return (val).toFixed(0);
      //   }
      labels: {
        formatter: function (val) {
          return val.toFixed(0)
        },
        style: {
          // colors: '#8a00e5',
          fontFamily: 'Siemens Sans',
        },
      },
      title: {
        text: 'Price',
        style: {
          // color: '#8a00e5',
          fontFamily: 'Siemens Sans',
          fontSize: '1rem',
        },
      },
    }

    this.xaxis = {
      type: 'datetime',
      categories: dates,
      labels: {
        style: {
          // colors: '#8a00e5',
          fontFamily: 'Siemens Sans',
        },
      },
    }
    this.tooltip = {
      shared: false,
      cssClass: 'legend-x',
      intersect: true,
      onDatasetHover: {
        highlightDataSeries: true,
      },
      style: {
        // fontSize: string,
        fontFamily: 'Siemens Sans',
      },
      y: {
        formatter: function (val) {
          console.log(val)
          return val.toFixed(0)
        },
      },
    }
  }

  processData(data: any) {
    console.log(data)
    let dataSeries = []
    let temp: any = { date: '', value: '' }
    // let date;
    for (let item of data) {
      temp = {}
      // date = item['ERDAT'].replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
      if (!this.showQuoteGraph) {
        temp['date'] = item['ERDAT']
        temp['price'] = item['NETPR_EUR']
      } else {
        temp['date'] = new Date(item['CREATEDDATE']).toISOString();
        temp['price'] = item['NET_UNIT_PRICE_EURO__C']
      }
      dataSeries.push(temp)
    }
    this.initChartData(dataSeries)
  }
}
